module.exports = __webpack_public_path__ + "media/images/pic/saska/hero-individual-51b678f8b3272aab8f9a9c7321840277.png";